import {
  GET_CASTING_ROLES,
  GET_CASTING_ROLE,
  INSERT_CASTING_ROLE,
  UPDATE_CASTING_ROLE,
  DELETE_CASTING_ROLE,
  GET_CASTING_CANDIDATES,
  INSERT_CASTING_CANDIDATE,
  DELETE_CASTING_CANDIDATE,
  CLEAR_CASTING_ROLE,
} from "./casting.type";

const initialState = {
  roles: [],
  total: 0,
  role: null,
  candidates: [],
};

const castingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CASTING_ROLES:
      return { ...state, roles: action.payload.roles, total: action.payload.total };

    case GET_CASTING_ROLE:
      return { ...state, role: action.payload };

    case INSERT_CASTING_ROLE:
      return { ...state, roles: [action.payload, ...state.roles], total: state.total + 1 };

    case UPDATE_CASTING_ROLE:
      return {
        ...state,
        roles: state.roles.map((role) => (role._id === action.payload.id ? action.payload.data : role)),
        role: state.role && state.role._id === action.payload.id ? action.payload.data : state.role,
      };

    case DELETE_CASTING_ROLE:
      return {
        ...state,
        roles: state.roles.filter((role) => role._id !== action.payload),
        total: Math.max(0, state.total - 1),
      };

    case GET_CASTING_CANDIDATES:
      return { ...state, candidates: action.payload };

    case INSERT_CASTING_CANDIDATE:
      // Keep the list ordered by vote count without a refetch.
      return {
        ...state,
        candidates: [...state.candidates, action.payload].sort((a, b) => (b.voteCount || 0) - (a.voteCount || 0)),
      };

    case DELETE_CASTING_CANDIDATE:
      return { ...state, candidates: state.candidates.filter((c) => c._id !== action.payload) };

    case CLEAR_CASTING_ROLE:
      return { ...state, role: null, candidates: [] };

    default:
      return state;
  }
};

export default castingReducer;
